"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toastContent = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var toastContent = function (icon, topText, mainText) { return (react_1.default.createElement("div", { className: "estimateForm-ToastContent" },
    react_1.default.createElement("div", { className: "estimateForm-ToastContent_IconWrapper" },
        react_1.default.createElement("i", { className: (0, classnames_1.default)('fa', "fa-".concat(icon)) })),
    react_1.default.createElement("div", { className: "estimateForm-ToastContent_TextWrapper" },
        react_1.default.createElement("div", { className: "estimateForm-ToastContent_TopText" }, topText),
        react_1.default.createElement("div", { className: "estimateForm-ToastContent_MainText" }, mainText)))); };
exports.toastContent = toastContent;
